"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_core_1 = require("@patternfly/react-core");
const common_1 = require("../../../common");
const react_1 = tslib_1.__importDefault(require("react"));
const ClusterLoading = () => (react_1.default.createElement(react_core_1.PageSection, { variant: react_core_1.PageSectionVariants.light, isFilled: true },
    react_1.default.createElement(common_1.LoadingState, null)));
exports.default = ClusterLoading;
//# sourceMappingURL=ClusterLoading.js.map